<template lang="pug">
v-card(outlined)
  v-card-title Время автоматического истечения заявок
  v-card-text.d-flex.align-center.justify-center
    v-slider(
      dense
      v-model="whenExpiry"
      label="Укажите время истечение заявок"
      thumb-label="always"
      step="1"
      max="7"
      min="1"
      color="primary")
    v-btn.mb-5(color="success" @click="setNewSettings" :disabled="indexSettings === whenExpiry") Сохранить изменения
</template>
<script>
import { showRegion } from '@/services/API/_common';
import CRUDRegionSettings from '@/services/API/region-settings';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      region: {},
      indexSettings: null,
      whenExpiry: null,
      regionSettings: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  async created() {
    await this.fetchRegion();
    if (!this.region.region_setting) await this.createRegionSettings();
    await this.fetchRegionSettings();
  },
  methods: {
    async fetchRegionSettings() {
      const { id } = this.region.region_setting;
      if (!id) return;
      try {
        const response = await CRUDRegionSettings.get(id);
        this.regionSettings = response.data.data;
        this.indexSettings = this.regionSettings.client_question_auto_close_day;
        this.whenExpiry = this.indexSettings;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async fetchRegion() {
      const { region_id } = this.user;
      if (!region_id) return;
      try {
        const response = await showRegion(region_id, { 'expand': 'region_setting' });
        this.region = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async createRegionSettings() {
      try {
        const params = {
          'region_id': this.region.id,
          'client_question_auto_close_day': 1,
          'timezone_id': 1,
        };
        await CRUDRegionSettings.create(params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async setNewSettings() {
      try {
        const params = {
          'client_question_auto_close_day': this.whenExpiry,
          'timezone_id': 4,
        };
        const { id } = this.regionSettings;
        // console.log(id);
        await CRUDRegionSettings.update(id, params);
        this.indexSettings = this.whenExpiry;
        this.$toast.success('Настройки сохранены');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
        // console.log(e);
      }
    },
  },
};
</script>
<style lang="sss" scoped/>
